import {useCallback} from 'react'

import {ASPECT_RATIO_TYPES, DEFAULT_OPTIONS, IMAGE_TYPES, TRANSFORM_TYPES} from './config.js'
import HookUseImageUrlAdapter from './fake-component.js'
import {getTransformedImage} from './utils.js'

function getImagesUrlsAdapted({images = [], options}) {
  return images.map(({src, ...rest}) => {
    if (typeof src !== 'string') return {...rest}

    const transformedImage = getTransformedImage({
      imageUrl: src,
      options
    })

    return {src: transformedImage, ...rest}
  })
}

const useImageUrlAdapter = () => {
  const getImages = useCallback(
    getImagesUrlsAdapted,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return ({images = [], options = DEFAULT_OPTIONS}) => ({
    images: getImages({images, options})
  })
}

export {
  IMAGE_TYPES as imageUrlAdapterImageTypes,
  TRANSFORM_TYPES as imageUrlAdapterTransformTypes,
  ASPECT_RATIO_TYPES as imageUrlAdapterAspectRatios
}

export {useImageUrlAdapter, getImagesUrlsAdapted}
export default HookUseImageUrlAdapter
